import { JsonFormsCellRendererRegistryEntry, JsonFormsRendererRegistryEntry } from '@jsonforms/core';
import { UnsupportedRenderer } from './UnsupportedRenderer';
import { GroupRenderer } from './GroupRenderer';
import { InputControl } from './InputControl';
import { TextCell } from '../cells/TextCell';
import { EnumCell } from '../cells/EnumCell';
import { LabelRenderer } from './LabelRenderer';
import { ArrayCell } from '../cells/ArrayCell';
import { IntegerCell } from '../cells/IntegerCell';
import { LongPositiveIntegerCell } from '../cells/LongPositiveIntegerCell';
import { BooleanCell } from '../cells/BooleanCell';
import { RichTextRenderer } from './RichTextRenderer';

/**
 * All high level renderers for supporting dynamic forms on RN.
 */
export const reactNativeRenderers: JsonFormsRendererRegistryEntry[] = [
  InputControl,
  GroupRenderer,
  LabelRenderer,
  RichTextRenderer,
  UnsupportedRenderer,
];

/**
 * All cell renderers for supporting dynamic forms on RN.
 */
export const reactNativeCells: JsonFormsCellRendererRegistryEntry[] = [
  TextCell,
  LongPositiveIntegerCell,
  IntegerCell,
  BooleanCell,
  EnumCell,
  ArrayCell,
  UnsupportedRenderer,
];
